<template>
    <div>
        <h2 class="heading-l fw-bold mb-4 mb-lg-3">Consultation Methods Analysis Report</h2>
        <p class="heading-s fw-bold">
            {{ dayjs(filters.fromDateTime).format('DD MMM YYYY') }} - {{ dayjs(filters.toDateTime).format('DD MMM YYYY') }}
        </p>
    </div>
    <AnalyticsDataCard
        :is-busy="isBusy"
        :loaded="analyticsConsultationsRecords ? true : false"
        class="flex-grow-1 card border">
        <h3 class="fw-bold heading-m mb-4">Consultation Method</h3>
        <div v-if="analyticsConsultationsRecords && consultationMethodAnalysisRecords">
            <Pie
                v-if="consultationMethodAnalysisRecords.items.length > 0"
                :data="{
                    labels: consultationMethodNames,
                    datasets: [
                        {
                            label: 'Count',
                            data: consultationMethodAnalysisRecords.items[0].consultationMethodFrequencyRecords.map(x => x.count),
                            backgroundColor: appConstants.CHART_COLOURS
                        }
                    ]
                }"
                :plugins="[ChartDataLabels]"
                :options="{
                    plugins: {
                        legend: {
                            position: 'bottom'
                        },
                        datalabels: {
                            color: '#fff',
                            formatter: (value, ctx) => {
                                let sum = 0;
                                let dataArr = ctx.chart.data.datasets[0].data;
                                //@ts-ignore
                                dataArr.map(data => {
                                    //@ts-ignore
                                    sum += data;
                                });
                                //@ts-ignore
                                let percent = (value * 100) / sum;
                                //@ts-ignore
                                let percentage = percent === 0 ? '' : `${percent.toFixed(1)}%`;
                                //@ts-ignore
                                return percentage;
                            },
                            textAlign: 'center',
                            font: {
                                size: largerThanLg ? 18 : 14,
                                weight: 'bold',
                                family: 'Raleway'
                            },
                            clamp: true,
                            display: 'auto'
                        }
                    }
                }"
            ></Pie>
            <p v-else class="mb-0">
                No data found.
            </p>
        </div>
        <p v-else class="mb-0">
            No data found.
        </p>
    </AnalyticsDataCard>
</template>

<script lang="ts" setup>
// import AppConstants from '@/modules/proportal/app.constants';
import { AnalyticsDataCard } from '.';
import { storeToRefs } from 'pinia';
import { useAnalyticsConsultationsStore, useCommonDataStore } from '@/modules/proportal/store';
import { breakpointsBootstrapV5, useBreakpoints } from "@vueuse/core";
import dayjs from 'dayjs';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    Colors 
} from 'chart.js'
import { Pie } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import appConstants from '@/modules/proportal/app.constants';
import { computed } from 'vue';
ChartJS.register(Title, Tooltip, Legend, ArcElement, Colors);

const breakpoints = useBreakpoints(breakpointsBootstrapV5);
const largerThanLg = breakpoints.greater('lg');

const analyticsConsultationsStore = useAnalyticsConsultationsStore();
const { isBusy, filters, analyticsConsultationsRecords, consultationMethodAnalysisRecords } = storeToRefs(analyticsConsultationsStore);

const consultationMethodNames = computed(() => {
    return consultationMethodAnalysisRecords.value?.items[0].consultationMethodFrequencyRecords.map(x => x.consultationMethod.name)
})

// const commonDataStore = useCommonDataStore();
// const { consultationMethods } = storeToRefs(commonDataStore);

analyticsConsultationsStore.load()
</script>